<template>
  <section
    class="info-card-slider"
    :class="cardColor"
    :style="{
      backgroundColor: props.backgroundColor,
    }">
    <FullSlider manual-height>
      <template #sliderContent>
        <SwiperSlide v-for="(card, index) in props.infoCards" :key="index">
          <InfoCard v-bind="card" />
        </SwiperSlide>
      </template>
    </FullSlider>
  </section>
</template>

<script lang="ts" setup>
import { SwiperSlide } from 'swiper/vue'

import type { InfoCardStyleOptions, TranslatableString } from '~/types/widgets/widgetTypes'
import InfoCard from '~/components/Widgets/InfoCard/InfoCard.vue'
import FullSlider from '~/components/FullSlider.vue'

interface Props {
  infoCards: {
    title: TranslatableString
    description: TranslatableString
    slug?: string
    image?: TranslatableString
    icon?: TranslatableString
    staticIcon?: string
  }[]
  backgroundColor?: string
  cardsStyle?: InfoCardStyleOptions[] | InfoCardStyleOptions | string
}

const props = defineProps<Props>()

const cardColor = computed<string>(() => {
  const style = Array.isArray(props.cardsStyle) ? props.cardsStyle[0] : props.cardsStyle

  return `card-${String(style).toLowerCase()}`
})
</script>

<style lang="postcss">
.info-card-slider {
  &.card-white {
    .info-card {
      .info-card-inner {
        @apply bg-white dark:bg-dmGray2;
        border-color: transparent;

        .card-icon,
        .card-image {
          @apply bg-white dark:bg-dmGray2;
        }
      }
    }
  }

  &.card-gray {
    .info-card {
      .info-card-inner {
        @apply bg-gray1 dark:bg-dmGray1;

        .card-icon,
        .card-image {
          @apply bg-gray1 dark:bg-dmGray1;
        }
      }
    }
  }
}
</style>
